import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openPermissions: {
		id: 'servicedesk.channels-jsd.channels.customer-access.open-permissions',
		defaultMessage: 'All customers have access',
		description: 'Description for open customer permissions',
	},
	open: {
		id: 'servicedesk.channels-jsd.channels.customer-access.open',
		defaultMessage: 'All customers',
		description: 'Description for open customer permissions',
	},
	restrictedPermissions: {
		id: 'servicedesk.channels-jsd.channels.customer-access.restricted-permissions',
		defaultMessage: 'Only invited customers have access ',
		description: 'Description for restricted customer permissions',
	},
	restricted: {
		id: 'servicedesk.channels-jsd.channels.customer-access.restricted',
		defaultMessage: 'Only invited customers',
		description: 'Description for restricted customer permissions',
	},
	configure: {
		id: 'servicedesk.channels-jsd.channels.customer-access.configure',
		defaultMessage: 'Configure',
		description: 'Configure a channel',
	},
	configureLabelDescriptive: {
		id: 'servicedesk.channels-jsd.channels.customer-access.label-descriptive',
		defaultMessage: 'Configure channel access',
		description: 'Configure a channel access',
	},
	label: {
		id: 'servicedesk.channels-jsd.channels.customer-access.label',
		defaultMessage: 'CHANNEL ACCESS',
		description: 'label for customer permissions item in channels popup',
	},
	itemLabel: {
		id: 'servicedesk.channels-jsd.channels.customer-access.item-label',
		defaultMessage: 'Channel access',
		description: 'label for customer permissions item in channels popup',
	},
});
